import { createAction, createReducer } from '@reduxjs/toolkit';
import { fetchGroupcallData } from '../dataFetcher/dataFetcher';
import { setAnalyticsFromGroupcall } from '../analytics/analyticsFromGroupcall';
import { parseNumberOfItemsInBasketFromGroupcallData } from './helpers/configurationHelpers';


// 1. Initial state
const initialState = {};

// 2. Action creators
export const setGroupcall = createAction('configuration/SET_GROUPCALL');
export const setNavigationData = createAction('configuration/SET_NAVIGATION_DATA');


// 3. Complex actions which call basic actions above
export const loadAndSetGroupcall = () => async (dispatch) => {
  const groupcallData = await fetchGroupcallData();
  dispatch(setGroupcall(groupcallData));

  if (groupcallData.digitalData) {
    dispatch(setAnalyticsFromGroupcall(groupcallData.digitalData));
  }
};


// 4. Reducer
/* eslint-disable no-param-reassign */
export default createReducer(initialState, {
  [setGroupcall]: (stateDraft, action) => {
    stateDraft.user = action.payload.state ? action.payload.state.userDetails : {};
    stateDraft.user.isLoggedIn = !!(stateDraft.user.email && stateDraft.user.first_name && stateDraft.user.last_name);
    stateDraft.itemsInBasket = parseNumberOfItemsInBasketFromGroupcallData(action.payload);
    stateDraft.userPostcode = (action.payload?.state?.lastPostCode && typeof action.payload.state.lastPostCode === 'string')
      ? action.payload.state.lastPostCode : null;
    stateDraft.groupcallLoaded = true;
      
    if (action.payload.session) {
      stateDraft.session = action.payload.session;
    }
  },
  [setNavigationData]: (stateDraft, action) => {
    stateDraft.navigationData = action.payload;
  }
});
